import React, {FunctionComponent} from "react";
import {Box, makeStyles} from "@material-ui/core";
import CheckBox from "../../../commonComponents/CheckBox";
import WizardStep from "../WizardStep";
import progressPayment from "../../../images/Progress/progress_payment.svg";
import {Step} from "../../WizardMap";
import {useDispatch, useSelector} from "react-redux";
import {setPaymentType} from "../../state/contactSlice";
import {RootState} from "../../../redux/rootReducer";
import {PaymentType} from "../../../API";
import {NavigationProps} from "../../slideRouter/navigationHook";
import Text from "../../../commonComponents/Text";

const useStyle = makeStyles(theme => ({
    paymentContainer: {
        display: "flex",
        flex: 1,
        flexDirection: "column"
    }
}));

const StepPayment: FunctionComponent<NavigationProps> = ({gotoNextSlide, gotoPrevSlide}) => {

    const classes = useStyle();

    const dispatch = useDispatch();

    const {paymentType} = useSelector((state: RootState) => state.contact);

    return (
        <WizardStep
            title={"Bitte wählen Sie eine Auszahlungsart"}
            description={paymentType === PaymentType.TRANSFER
                ? "Ihre Bankdaten werden aus Sicherheitsgründen später abgefragt"
                : "Ihre PayPal-Daten werden aus Sicherheitsgründen später abgefragt"
            }
            icon={progressPayment}
            backButton
            onBackClick={gotoPrevSlide}
            nextButton
            onNextClick={() => gotoNextSlide(Step.SUMMARY)}
        >
            <Box className={classes.paymentContainer}>
                <CheckBox
                    text={"PayPal"}
                    checked={paymentType === PaymentType.PAYPAL}
                    onClick={() => dispatch(setPaymentType(PaymentType.PAYPAL))}
                    style={{marginBottom: 20}}
                    select
                />
                <CheckBox
                    text={"Überweisung"}
                    checked={paymentType === PaymentType.TRANSFER}
                    onClick={() => dispatch(setPaymentType(PaymentType.TRANSFER))}
                    style={{marginBottom: 20}}
                    select
                />
                <Box marginTop={2}>
                    <Box
                        bgcolor={"rgba(255,255,255, 0.5)"} // deactivates cash for now
                        width={120}
                        height={35}
                        zIndex={20}
                        position={"absolute"}
                    />
                    <Text value={"coming soon"} size={10}/>
                    <CheckBox
                        text={"Barauszahlung"}
                        checked={paymentType === PaymentType.CASH}
                        onClick={() => dispatch(setPaymentType(PaymentType.CASH))}
                        select
                        disabled
                        style={{marginTop: 5}}
                    />
                </Box>
            </Box>
        </WizardStep>
    );
};

export default StepPayment;
